export const UNDECLARED_LICENSE = "Undeclared";
export const CRYPTO_ASSET_KIND = {
    algorithm: "ALGORITHM",
    certificate: "CERTIFICATE",
    material: "MATERIAL",
    protocol: "PROTOCOL",
};
export const CRYPTO_ASSET_KIND_LABEL = {
    ALGORITHM: "Algorithm",
    CERTIFICATE: "Certificate",
    MATERIAL: "Material",
    PROTOCOL: "Protocol",
};
export const ASSESSMENT_TYPE_TO_TITLE = {
    hardening: "Hardening",
    licenses: "Licenses",
    secrets: "Secrets",
    vulnerabilities: "Vulnerabilities",
    malware: "Malware",
    tampering: "Tampering",
};
export const categoryToTitle = {
    threats: "Malware detection",
    vulnerabilities: "Known vulnerabilities",
    signatures: "Digital signatures",
    hardening: "Application hardening",
    containers: "Container security",
    secrets: "Sensitive information",
    licenses: "License compliance",
    integrity: "Package integrity",
    hunting: "Threat hunting",
    "diff-hunting": "Differential analysis",
    yara: "YARA policies",
};
export const TRANSFORM_EXPLOIT_FLAG = {
    EXISTS: "Exploits exist",
    MALWARE: "Exploited by malware",
    MANDATE: "Patching mandated",
    TRIAGED: "Vulnerability triaged",
    UNPROVEN: "Exploits unknown",
    FIXABLE: "Fix available",
};
export const TRANSFORM_LINKING = {
    dynamic: "Dynamically linked dependency",
    package: "Package dependency",
    static: "Statically linked dependency",
};
export const COMMUNITY_TYPE_TO_TEXT = {
    containers: "Containers",
    general: "General",
    go: "Go",
    java: "Maven",
    linux: "Linux",
    macos: "MacOS",
    managed: "NuGet",
    nodejs: "npm",
    php: "PHP",
    python: "PyPI",
    ruby: "RubyGems",
    rust: "crates.io",
    windows: "Windows",
    vscode: "VS Code",
    ai: "AI",
    powershell: "PowerShell",
};
export const SECRET_LIVENESS_SHORT_LABEL = {
    skipped: "Skipped",
    "site-unknown": "Unknown",
    "site-offline": "Offline",
    "site-timeout": "Timeout",
    "rate-limited": "Limited",
    "site-error": "Error",
    active: "Active",
    inactive: "Inactive",
};
//# sourceMappingURL=metadataEnumsToLabels.js.map